import { defineMessages } from 'react-intl';

const messages = defineMessages({
  uncommitted: {
    description: 'Label Provider connection status - uncommitted',
    defaultMessage: 'Uncommitted',
    id: 'tDiXsl',
  },
  active: {
    description: 'Label Provider connection status - active',
    defaultMessage: 'Active',
    id: 'Yc37tX',
  },
  inactive: {
    description: 'Label Provider connection status - inactive',
    defaultMessage: 'Inactive',
    id: 'X/fp7w',
  },
  declined: {
    description: 'Label Provider connection status - declined',
    defaultMessage: 'Declined',
    id: 'Z8XAbV',
  },
  pending: {
    description: 'Label Provider connection status - pending',
    defaultMessage: 'Pending',
    id: 'Xc/Pw7',
  },
});

export const SellerProviderStatusEnum = {
  // This typically means that the SellerProvider hasn't been persisted (yet) / is being created.
  uncommitted: {
    value: 'Uncommitted',
  },
  active: {
    value: 'Active',
  },
  inactive: {
    value: 'Inactive',
  },
  declined: {
    value: 'Declined',
  },
  pending: {
    value: 'Pending',
  },
};

Object.keys(SellerProviderStatusEnum).forEach((setting) => {
  if (messages[setting]) {
    SellerProviderStatusEnum[setting].messageDescriptor = messages[setting];
  }
});
